<template>
    <div v-if="resultados.length === 0">
        <span class="nao-ha-restricoes">
            {{ $tc('certification.messages.no_restrictions') }}!
        </span>
    </div>
    <div v-else>
        <div
            class="item-info"
            v-for="resultado in resultados"
            :key="resultado.id"
        >
            <div>
                <div
                    class="item-info-crosshairs-gps-icon"
                    v-if="mapaLeaflet && possuiGeometria(resultado)"
                    @click="aplicarZoomGeoJson(resultado)"
                >
                    <i class="mdi mdi-crosshairs-gps"></i>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.ano || resultado.ano"
                >
                    <label>{{ $tc('certification.words.year') }}:</label>
                    <span>{{
                        resultado.properties?.ano || resultado.ano
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.ano_acao_fiscal ||
                        resultado.ano_acao_fiscal
                    "
                >
                    <label
                        >{{
                            $tc('certification.words.fiscal_action_year')
                        }}:</label
                    >
                    <span>{{
                        resultado.properties?.ano_acao_fiscal ||
                        resultado.ano_acao_fiscal
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.dano || resultado.dano"
                >
                    <label>{{ $tc('certification.words.damage') }}:</label>
                    <span>{{
                        resultado.properties?.dano || resultado.dano
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.tipo || resultado?.tipo"
                >
                    <label>{{ $tc('certification.words.type') }}:</label>
                    <span>{{
                        resultado.properties?.tipo || resultado?.tipo
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.cultura || resultado.cultura"
                >
                    <label
                        >{{
                            $tc('certification.messages.planted_culture')
                        }}:</label
                    >
                    <span>{{
                        resultado.properties?.cultura || resultado.cultura
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.nome || resultado.nome"
                >
                    <label>{{ $tc('certification.words.name') }}:</label>
                    <span>{{
                        resultado.properties?.nome || resultado.nome
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.codigo_cnuc ||
                        resultado.codigo_cnuc
                    "
                >
                    <label
                        >{{ $tc('certification.messages.cnuc_code') }}:</label
                    >
                    <span>{{
                        resultado.properties?.codigo_cnuc ||
                        resultado.codigo_cnuc
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.areaHa || resultado.areaHa"
                >
                    <label>{{ $tc('certification.words.area') }}:</label>
                    <span>{{
                        formatArea(
                            resultado.properties?.areaHa || resultado.areaHa,
                            2
                        ) || '-'
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.percentualSobreposicaoGeometria ||
                        resultado.percentualSobreposicaoGeometria
                    "
                >
                    <label
                        >{{
                            $tc('certification.messages.overlap_percentage')
                        }}
                        (ha):</label
                    >
                    <span>{{
                        getPercentualSobreposicaoGeometriaFormatado(
                            resultado.properties
                                ?.percentualSobreposicaoGeometria ||
                                resultado.percentualSobreposicaoGeometria,
                            2
                        )
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.fazenda || resultado.fazenda"
                >
                    <label>{{ $tc('certification.words.farm') }}:</label>
                    <span>{{
                        resultado.properties?.fazenda || resultado.fazenda
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.estabelecimento ||
                        resultado.estabelecimento
                    "
                >
                    <label
                        >{{ $tc('certification.words.establishment') }}:</label
                    >
                    <span>{{
                        resultado.properties?.estabelecimento ||
                        resultado.estabelecimento
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.proprietario ||
                        resultado.proprietario
                    "
                >
                    <label>{{ $tc('certification.words.owner') }}:</label>
                    <span>{{
                        resultado.properties?.proprietario ||
                        resultado.proprietario
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.empregador || resultado.empregador
                    "
                >
                    <label>{{ $tc('certification.words.employer') }}:</label>
                    <span>{{
                        resultado.properties?.empregador || resultado.empregador
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.cpf_cnpj || resultado.cpf_cnpj"
                >
                    <label>CPF/CNPJ:</label>
                    <span>{{
                        formatCpfCnpj(
                            resultado.properties?.cpf_cnpj || resultado.cpf_cnpj
                        ) || '-'
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.descricao || resultado.descricao
                    "
                >
                    <label>{{ $tc('certification.words.description') }}:</label>
                    <span>{{
                        resultado.properties?.descricao || resultado.descricao
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.cnae || resultado.cnae"
                >
                    <label>CNAE:</label>
                    <span>{{
                        resultado.properties?.cnae || resultado.cnae
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.uf || resultado.uf"
                >
                    <label>UF:</label>
                    <span>{{ resultado.properties?.uf || resultado.uf }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="resultado.properties?.latitude || resultado.latitude"
                >
                    <label>{{ $tc('certification.words.latitude') }}:</label>
                    <span>{{
                        resultado.properties?.latitude || resultado.latitude
                    }}</span>
                </div>
                <div
                    class="info-resultado"
                    v-if="
                        resultado.properties?.longitude || resultado.longitude
                    "
                >
                    <label>{{ $tc('certification.words.longitude') }}:</label>
                    <span>{{
                        resultado.properties?.longitude || resultado.longitude
                    }}</span>
                </div>
                <div class="info-resultado" v-if="resultado.mensagem">
                    <span>{{ resultado.mensagem }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatter from '@/utils/formatters.js';

export default {
    name: 'InformacoesRestricao',

    props: {
        resultados: {
            type: Array,
            required: true
        },
        mapaLeaflet: {
            type: Object,
            required: false
        }
    },

    methods: {
        formatArea(value, decimalPlaces = 2) {
            return formatter.maxFormatNumber(value, decimalPlaces);
        },

        getPercentualSobreposicaoGeometriaFormatado(
            percentual,
            decimalPlaces = 2
        ) {
            const percent = formatter.maxFormatNumber(
                percentual,
                decimalPlaces
            );
            return percent !== '-' ? percent + '%' : percent;
        },

        formatCpfCnpj(cpfCnpj) {
            return formatter.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        aplicarZoomGeoJson(resultado) {
            const geometria = resultado.geometria || resultado.geometry;
            this.mapaLeaflet.aplicarZoomGeoJson(geometria);
        },

        possuiGeometria(resultado) {
            return (
                resultado.geometria ||
                resultado.geometry ||
                (resultado.properties?.latitude &&
                    resultado.properties?.longitude)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.nao-ha-restricoes {
    padding-left: 7px;
}

.item-info {
    border: 1px solid $default-border-color;
    background-color: $white;
    padding: 12px;
    border-radius: $default-border-radius;
}

.item-info-crosshairs-gps-icon {
    width: 40px;
    height: 35px;
    background-color: $selected-background-color;
    border-radius: $default-border-radius;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $default-border-color;
    margin-bottom: 10px;
}

.info-resultado {
    display: flex;
    gap: 5px;
    overflow-x: scroll;
}

.info-resultado label {
    font-weight: bold;
}
</style>
